import SiafLiteApiRepository from "../../external/siafLiteApi";

class UnidadeComercialService {
  constructor() {
    this.urlBase = "/estoque/unidades-comerciais";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default UnidadeComercialService;
